// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';

export default class Link extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    dataTestID: PropTypes.string,
  };

  render() {
    const { styles } = Link;

    return (
      <a
        href="#"
        className={cx(this.props.className, styles.link)}
        onClick={this.handleClick}
        data-testid={this.props.dataTestID}
      >
        {this.props.children}
      </a>
    );
  }

  handleClick = (event) => {
    event.preventDefault();

    this.props.onClick();
  };
}

const styles = cssInJS({
  link: {
    WebkitFontSmoothing: 'antialiased',

    // ':hover': {
    //   color: '#348dca',
    //   border: THEME.buttonBorderHighlight
    // }
  },
});

Link.styles = styles;
